import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AssessmentRequestAnswerLink } from '../../models/assessment.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BehavioralAssessmentService {
  constructor(private http: HttpClient) {}

  public getAnswerLink(requestId: string): Observable<AssessmentRequestAnswerLink | null> {
    return this.http
      .get<AssessmentRequestAnswerLink>(
        `${environment.applicantApiEndpoint}/behavioral-assessments/answer/${requestId}/link`,
      )
      .pipe(
        catchError((e) => {
          if (e instanceof HttpErrorResponse && e.status === 404) {
            return of(null);
          }
          return throwError(() => e);
        }),
      );
  }
}
